
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M18 2a3.6 3.6 0 013.6 3.6v9.599a2.4 2.4 0 011.77 4.02l-.383.418a4.8 4.8 0 01-3.542 1.561H4.269a4.454 4.454 0 01-4.02-2.534A2.4 2.4 0 012.402 15.2V5.6A3.6 3.6 0 016.001 2H18zm3.6 15.599H2.4a2.054 2.054 0 001.868 1.2h15.176c.674 0 1.316-.284 1.771-.78l.384-.42zM18 4.399H6a1.2 1.2 0 00-1.2 1.2v9.6h14.4v-9.6A1.2 1.2 0 0018 4.4zm-9.06 5.76a.9.9 0 01.9.9v1.44a.9.9 0 01-.9.9H7.5a.9.9 0 01-.9-.9v-1.44a.9.9 0 01.9-.9zm3.96 0a.9.9 0 01.9.9v1.44a.9.9 0 01-.781.892l-.119.008h-1.44a.9.9 0 01-.9-.9v-1.44a.9.9 0 01.9-.9h1.44zm-3.96.72H7.5c-.1 0-.18.08-.18.18v1.44a.18.18 0 00.18.18h1.44a.18.18 0 00.18-.18v-1.44c0-.1-.08-.18-.18-.18zm0-4.68a.9.9 0 01.9.9v1.44a.9.9 0 01-.9.9H7.5a.9.9 0 01-.9-.9V7.1a.9.9 0 01.9-.9zm3.96 0a.9.9 0 01.9.9v1.44a.9.9 0 01-.9.9h-1.44a.9.9 0 01-.9-.9V7.1a.9.9 0 01.9-.9z"}})])
          )
        }
      }
    